import React from "react";
import { useCreateFuelExpenseRateMutation } from "./queries.generated";
import { MutationForm } from "~/components/forms/MutationForm";
import { CreateExpenseRateFormData, CreateExpenseRateFormProps } from "./types";
import { ValidationResponse } from "~/gql/types";

export const NewFuelExpenseRate: React.FC<CreateExpenseRateFormProps> = (
  props
) => {
  const { setLoading, onSuccess, initialValues, rateSheetName, children } =
    props;

  const [rawFuelMutation] = useCreateFuelExpenseRateMutation();

  const handleSubmit = async (values: CreateExpenseRateFormData) => {
    const variables = {
      name: values?.name!,
      invoiceLabel: values?.invoiceLabel || null,
      expenseAccount: values?.expenseAccount || null,
      glAccount: values?.glAccount || null,
      rateSheetName: rateSheetName,
      billable: values?.billable,
    };

    const result = await rawFuelMutation({ variables });

    return result?.data?.expenseRates?.addFuelRate as ValidationResponse;
  };

  return (
    <MutationForm
      setLoading={setLoading}
      initialValues={initialValues}
      runMutation={handleSubmit}
      onSuccess={onSuccess}
      allowPristineSubmit
    >
      {children}
    </MutationForm>
  );
};
